module.exports = __webpack_public_path__ + "static/media/onboardingThird.0caab9d7.jpeg";